/**
 * Kí hiệu tiền tệ
 */
export default {
    NormalVND: 'đ',
    UpperCaseVND: 'Đ',
    Dola: '$',
    Eur: 'EUR',
    None: 0,
};
